import LayoutPage from "@/views/shared/LayoutPage"

export default [
    {
        path: '/errorPage',
        component: LayoutPage,
        children: [
            {
                path: "",
                name: "unauthorized",
                component: () => import("@/views/ErrorPage.vue"),
                meta: {
                    title: "Error Page",
                    titleLocalizationCode: "Error_Page",
                    desc: "Error page",
                    descLocalizationCode: "Error_Page",
                    sidebarElement: false
                },
                props: { logoFileName: "CentralAmerica.png" }
            },
        ],
        
    }
]


